import { NgModule } from '@angular/core';
import { SharedModule } from '../shared';
import {SubmitDealResolver} from './submit-resolver.service';
import {SubmitComponent} from './submit.component';
import {SubmitRoutingModule} from './submit-routing.module';
import {InputTextModule} from 'primeng/inputtext';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {EditorModule} from 'primeng/editor';
import {InputNumberModule} from 'primeng/inputnumber';
import {DropdownModule} from 'primeng/dropdown';
import {SelectButtonModule} from 'primeng/selectbutton';
import {GalleriaModule} from 'primeng/galleria';
import {ImageModule} from 'primeng/image';
import {ButtonModule} from 'primeng/button';
import {DialogModule} from 'primeng/dialog';
import {StepsModule} from 'primeng/steps';
import {CardModule} from 'primeng/card';
import {CalendarModule} from 'primeng/calendar';
import {NgxDropzoneModule} from 'ngx-dropzone';

@NgModule({
    imports: [SharedModule,
        SubmitRoutingModule,
        InputTextModule,
        InputTextareaModule,
        EditorModule,
        InputNumberModule,
        DropdownModule,
        SelectButtonModule,
        GalleriaModule, ImageModule, ButtonModule, DialogModule, StepsModule, CardModule, CalendarModule, NgxDropzoneModule],
    declarations: [SubmitComponent],
    providers: [SubmitDealResolver]
})
export class SubmitModule {}
